export default "__VITE_ASSET__DpWbQcLy__"